export class dashboardTimesheetDetails {
    public employeeName: string;
    public workDetails: any = [];
    public sunday: any;
    public monday: any;
    public tuesday: any;
    public wednesday: any;
    public thursday: any;
    public friday: any;
    public saturday: any;
    public totalHours: any;
    public hourSpent: number = 0;
    constructor(data: any, businessUnit) {
        if (businessUnit === 'ipdo' || businessUnit === 'biologics' || businessUnit === 'chinateam' || businessUnit === 'aps') {
            this.sunday = '00:00';
            this.monday = '00:00';
            this.tuesday = '00:00';
            this.wednesday = '00:00';
            this.thursday = '00:00';
            this.friday = '00:00';
            this.saturday = '00:00';
            this.totalHours = '00:00';
        } else if (businessUnit === 'accenture') {
            this.sunday = 0;
            this.monday = 0;
            this.tuesday = 0;
            this.wednesday = 0;
            this.thursday = 0;
            this.friday = 0;
            this.saturday = 0;
            this.totalHours = 0;
        }
        this.employeeName = data.empDetails.Empname;
        for (let i = 0; i < data.workDetails.length; i++) {
            this.workDetails.push(new workdetails(data.workDetails[i]));
        }
        this.workDetails.forEach(element => {
            this.hourSpent += this.convertHoursToMins(element.totalhrs);
            this.totalHours = this.convertMinsToHrsMins(this.hourSpent);
        });
    }

    convertHoursToMins(hrs) {
        const a = hrs.toString().split(':');
        let minutes = 0;
        if (a[1]) {
            minutes = (+(a[0])) * 60 + (+a[1]);
        } else {
            minutes = (+(Number(a[0]))) * 60;
        }
        return minutes;
    }

    convertMinsToHrsMins(mins) {
        const h: any = Math.floor(mins / 60);
        let m: any = mins % 60;
        m = Math.round(m);
        const hrs = h < 10 ? '0' + h : h;
        const mns = m < 10 ? '0' + m : m;
        return `${hrs}:${mns}`;
    }
}

export class workdetails {
    public date: string;
    public totalhrs: string;
    public dayparam: string;
    constructor(data: any) {
        this.date = data.dateDetails.date.split('T')[0];
        this.dayparam = this.date.split('-')[2];
        this.totalhrs = data.totalHrs;
    }
}

export class RmDashboard {
    public userDetails: UserDetail;
    public timespan: string;
    public requestType: string;
    constructor(data: any = {}) {
        this.userDetails = new UserDetail(data.UserDetails) || new UserDetail({});
        this.timespan = data.timespan || '';
        this.requestType = data.requestType || '';
    }
}

export class UserDetail {
    public Empno: string;
    constructor(d: any = {}) {
        this.Empno = d.Empno || '';
    }
}


// WEBPACK FOOTER //
// ./src/app/rm/dashboard/dashboard.ts